import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header__inner" }
const _hoisted_2 = { class: "header__title-wrapper" }
const _hoisted_3 = { class: "header__title" }

import { onBeforeMount, Raw, ref } from 'vue'

import { HeaderView } from '@/models/header'

import HeaderUserMenu from './UserMenu.vue'
import StartFreeTrialButton from './StartFreeTrialButton.vue'
import DocsSortButtonMobile from '@/app/components/listing/DocsSortButton.mobile.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Root',
  props: {
    title: null,
    hasDocSort: { type: Boolean, default: false }
  },
  setup(__props: any) {



const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header header--mobile", { 'header--ios': view.value.isIOS }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.title), 1)
      ]),
      (__props.hasDocSort)
        ? (_openBlock(), _createBlock(DocsSortButtonMobile, { key: 0 }))
        : _createCommentVNode("", true),
      (view.value.showCtaButtonOnMobile)
        ? (_openBlock(), _createBlock(StartFreeTrialButton, {
            key: 1,
            class: "header__trial-btn",
            view: view.value
          }, null, 8, ["view"]))
        : _createCommentVNode("", true),
      _createVNode(HeaderUserMenu, { view: view.value }, null, 8, ["view"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})